// @flow
import * as React from 'react';
import styled, { css } from 'styled-components';
import _ from 'lodash';
import { connect } from 'react-redux';
import { MAX_TRADES } from '../../helpers/team';
import { below } from '../../assets/css/media';
import { isMobile } from '../../utils';
import {
	TeamForTeamToTeamTrade,
	PlayersOnTrade,
} from '../';
import type { TTeamsDraftTradesReducer } from '../../modules/types';
import * as actions from '../../modules/actions';
type Props = {
	team_trade: TTeamsDraftTradesReducer,
	cancelTradeRequest: Function,
	league: Object,
	fetchMakeTrade: typeof actions.teamsDraft.fetchMakeTrade,
	MAX_TRADES: number,
	trade_error: String
};

type State = {
	team_id: number,
	team_trade: TTeamsDraftTradesReducer,
	show_confirm_modal: boolean,
	is_mobile: boolean,
	is_user: boolean
};
type TId = {
	id: number
}
const TeamToTeamTradeWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	> div {
		width: 49%;
	}
	
	${below.desktop`
		${css`
			width: 200%;
			justify-content: flex-start;
			margin-left: ${({ is_user }) => !is_user ? '-80%' : '0'};
			transition: margin-left 0.3s linear;
			
			> div {
				width: 45%;
				margin-right: 10px;
			}
		`}
	`}
`;

const TeamToTeamTradeWrapperOverflow = styled.div`
	width: 100%;
	overflow: hidden;
`;

export class TeamToTeamTradeComponent extends React.Component<Props, State> {
	state = {
		team_id: 0,
		team_trade: {
			old_player_id: [],
			new_player_id: []
		},
		show_confirm_modal: false,
		is_mobile: false,
		is_user: true
	};

	static defaultProps = {
		MAX_TRADES: MAX_TRADES
	};

	constructor(props: Props, state: State) {
		super(props, state);

		_.bindAll(this, [
			'handleTeamSelect',
			'removeOutPlayer',
			'removeInPlayer',
			'addOutTrade',
			'addInTrade',
			'makeTeamToTeamTrade',
			'resize',
			'changeView'
		]);
	}
	componentDidMount() {
		const { team_trade } = this.props;
		window.addEventListener("resize", this.resize);
		this.resize();

		this.setState({
			team_id: _.get(team_trade, 'owner_id', 0),
			team_trade
		});
	}
	componentWillUnmount() {
		window.removeEventListener("resize", this.resize);
	}
	removeOutPlayer({ id }: TId) {
		const { team_trade } = this.state;
		const { cancelTradeRequest } = this.props;
		const { new_player_id, old_player_id } = team_trade;
		const is_trade_remove = _.size(new_player_id.filter(id => id !== 0)) === 0;

		this.setState({
			team_trade: {
				...team_trade,
				old_player_id: _.xor(old_player_id, [id])
			}
		});
		if (is_trade_remove) {
			cancelTradeRequest();
		}
	}
	removeInPlayer({ id }: TId) {
		const { team_trade } = this.state;
		const { cancelTradeRequest } = this.props;
		const { new_player_id, old_player_id } = team_trade;
		const is_trade_remove = _.size(old_player_id.filter(id => id !== 0)) === 0;

		this.setState({
			team_trade: {
				...team_trade,
				new_player_id: _.xor(new_player_id, [id])
			}
		});

		if (is_trade_remove) {
			cancelTradeRequest();
		}
	}
	addOutTrade({ id }: TId) {
		const { MAX_TRADES } = this.props;
		const { team_trade } = this.state;
		const { old_player_id } = team_trade;
		const new_old_player_id = _.xor(old_player_id, [id]);

		if (new_old_player_id.length > MAX_TRADES) {
			return null;
		}

		this.setState({
			team_trade: {
				...team_trade,
				old_player_id: new_old_player_id
			}
		});
	}
	addInTrade({ id }: TId) {
		const { MAX_TRADES } = this.props;
		const { team_trade } = this.state;
		const { new_player_id } = team_trade;
		const new_new_player_id = _.xor(new_player_id, [id]);

		if (new_new_player_id.length > MAX_TRADES) {
			return null;
		}
		this.setState({
			team_trade: {
				...team_trade,
				new_player_id: new_new_player_id
			}
		});
	}
	makeTeamToTeamTrade() {
		const { league, fetchMakeTrade, cancelTradeRequest } = this.props;
		const { team_trade } = this.state;
		const { new_player_id, old_player_id } = team_trade;
		fetchMakeTrade({
			league_id: league.id,
			new_player_id,
			old_player_id
		});

		cancelTradeRequest();
	}
	handleTeamSelect(event: Object) {
		const { value } = event.target,
			team_id = parseInt(value, 10);
		const { team_trade } = this.state;

		this.setState({
			team_id,
			team_trade: {
				...team_trade,
				new_player_id: []
			}
		});
	}
	resize() {
		this.setState({
			is_mobile: isMobile()
		});
	}
	changeView(is_user: boolean) {
		this.setState({ is_user });
	}
	render() {
		const { cancelTradeRequest, league } = this.props;
		const { team_id, team_trade, is_mobile, is_user } = this.state;
		if (_.isEmpty(team_trade)) {
			return null;
		}

		return (
			<div>
				<PlayersOnTrade
					league={league}
					team={team_trade}
					type="team"
					cancelRequest={cancelTradeRequest}
					removeOutPlayer={this.removeOutPlayer}
					removeInPlayer={this.removeInPlayer}
					makeTeamToTeamTrade={this.makeTeamToTeamTrade}
				/>
				<TeamToTeamTradeWrapperOverflow>
					<TeamToTeamTradeWrapper is_user={is_user}>
						<TeamForTeamToTeamTrade
							league={league}
							is_user
							team_trade={team_trade}
							addOutTrade={this.addOutTrade}
							addInTrade={this.addInTrade}
							removeOutPlayer={this.removeOutPlayer}
							removeInPlayer={this.removeInPlayer}
							changeView={is_mobile && !is_user ? this.changeView : null}
						/>
						<TeamForTeamToTeamTrade
							league={league}
							is_user={false}
							team_id={team_id}
							team_trade={team_trade}
							handleTeamSelect={this.handleTeamSelect}
							addOutTrade={this.addOutTrade}
							addInTrade={this.addInTrade}
							removeOutPlayer={this.removeOutPlayer}
							removeInPlayer={this.removeInPlayer}
							changeView={is_mobile && is_user ? this.changeView : null}
						/>

					</TeamToTeamTradeWrapper>
				</TeamToTeamTradeWrapperOverflow>

			</div>

		);
	}
}
const mapStateToProps = state => {
	return {
		trade_error: state.teamsDraft.error
	};
};
const mapDispatchToProps = {
	fetchMakeTrade: actions.teamsDraft.fetchMakeTrade,
};
export const TeamToTeamTrade = connect(
	mapStateToProps,
	mapDispatchToProps,
)(TeamToTeamTradeComponent);

export default TeamToTeamTrade;


// WEBPACK FOOTER //
// ./src/components/Trades/TeamToTeamTrade.js